import { makeRequest } from 'services/request.service'

const TOKEN_KEY = 'lcost_token'
const USER_KEY = 'lcost_user'

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) } catch { return null }
}

export const getUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null') } catch { return null }
}

export const isAuthenticated = () => Boolean(getToken())

const persist = (token, user) => {
  try {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  } catch { /* ignore */ }
}

export const login = async (email, password) => {
  const data = await makeRequest({ method: 'POST', url: '/login', data: { email, password } })
  persist(data.token, data.user)
  return data.user
}

export const updateStoredUser = (patch) => {
  try { localStorage.setItem(USER_KEY, JSON.stringify({ ...getUser(), ...patch })) } catch { /* ignore */ }
}

// Self-service signup: no session until the emailed code is confirmed.
export const register = (payload) =>
  makeRequest({ method: 'POST', url: '/register', data: payload })

export const verifyEmail = async (email, code) => {
  const data = await makeRequest({ method: 'POST', url: '/verify-email', data: { email, code } })
  persist(data.token, data.user)
  return data.user
}

export const resendVerification = (email) =>
  makeRequest({ method: 'POST', url: '/verify-email/resend', data: { email } })

export const forgotPassword = (email) =>
  makeRequest({ method: 'POST', url: '/password/forgot', data: { email } })

export const resetPassword = async (email, code, password) => {
  const data = await makeRequest({ method: 'POST', url: '/password/reset', data: { email, code, password } })
  persist(data.token, data.user)
  return data.user
}

export const getUsage = async () => (await makeRequest({ method: 'GET', url: '/account/usage' })).usage

// Stable error code the API attaches to some errors (EMAIL_NOT_VERIFIED, TRIAL_LIMIT_REACHED…).
export const errorCode = (error) => error?.response?.data?.code || null

export const logout = () => {
  try {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
  } catch { /* ignore */ }
}
